import { render, staticRenderFns } from "./IconActive.vue?vue&type=template&id=25122e4d&"
import script from "./IconActive.vue?vue&type=script&lang=ts&"
export * from "./IconActive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports